import { isImmutable, Map, fromJS } from 'immutable'
import _ from 'lodash'
import { logError } from './error-logger'

export const safeSetIn = (obj, path, value) => {
  try {
    if (!isImmutable(obj)) {
      logError('safeSetIn', new Error('obj not an immutable object'), {
        path,
        value,
      })
      return Map()
    }
    if (!_.isArray(path)) {
      logError('safeSetIn', new Error('Path not an array'), {
        path,
        value,
      })
      return Map()
    }
    return obj.setIn(path, value)
  } catch (error) {
    if (String(error).includes('Cannot update within non-data-structure') && path?.length > 1) {
      let initial = _.initial(path)
      let state = obj.getIn(initial)
      if (isImmutable(state)) {
        state = state.toJS()
        _.set(state, [_.last(path)], value)
        return fromJS(state)
      } else {
        let state = obj.toJS()
        _.set(state, path, value)
        return fromJS(state)
      }
    } else {
      logError('safeSetIn', error, {
        path,
        value,
      })
      return obj
    }
  }
}
